module.exports = __webpack_public_path__ + "static/img/waiting.7e9b7f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/waiting.png
// module id = pCq1
// module chunks = 2